@if (show) {
  <div class="suggestion-settings-row">
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label i18n="@@dictionary.suggestions.targetSection.label">Suggestion target section</mat-label>
      <mat-select [value]="selectedSectionId" (selectionChange)="onSectionChange($event.value)">
        <mat-option [value]="DISABLED" i18n="@@dictionary.suggestions.disabled">&lt;Disabled&gt;</mat-option>
        @for (section of sections; track section.id) {
          <mat-option [value]="section.id">{{ section.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <span class="suggestion-settings-hint" i18n="@@dictionary.suggestions.targetSection.hint">Approved suggestions for this dictionary are created in this section in TermWeb</span>
  </div>
} @else {
  <p class="suggestion-settings-empty" i18n="@@dictionary.suggestions.tenantDisabled">Term suggestions are disabled for this tenant.</p>
}
